"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "peschiera-borromeo": {
    "60ad4afa": [{
      "hkey": "a8aad041",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "bellaria": [{
      "hkey": "a8aad041",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "peschiera-borromeo"
    }],
    "05028976": [{
      "hkey": "efadd40c",
      "slug": "mezzate",
      "name": "Mezzate",
      "primary": true,
      "skipSearch": false
    }],
    "bellingera": [{
      "hkey": "efadd40c",
      "slug": "mezzate",
      "name": "Mezzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "peschiera-borromeo"
    }],
    "001d928c": [{
      "hkey": "a8aad041",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "bettola": [{
      "hkey": "a8aad041",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2ca18c07": [{
      "hkey": "a8aad041",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "canzo": [{
      "hkey": "a8aad041",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "peschiera-borromeo"
    }],
    "165e34bc": [{
      "hkey": "a8aad041",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "foromagno": [{
      "hkey": "a8aad041",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "peschiera-borromeo"
    }],
    "28fe64be": [{
      "hkey": "dbe1bc8e",
      "slug": "peschiera-borromeo",
      "name": "Peschiera Borromeo",
      "primary": true,
      "skipSearch": false
    }],
    "palazzetto": [{
      "hkey": "dbe1bc8e",
      "slug": "peschiera-borromeo",
      "name": "Peschiera Borromeo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "47e73d8c": [{
      "hkey": "dbe1bc8e",
      "slug": "peschiera-borromeo",
      "name": "Peschiera Borromeo",
      "primary": true,
      "skipSearch": false
    }],
    "peschiera": [{
      "hkey": "dbe1bc8e",
      "slug": "peschiera-borromeo",
      "name": "Peschiera Borromeo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0079ae00": [{
      "hkey": "dbe1bc8e",
      "slug": "peschiera-borromeo",
      "name": "Peschiera Borromeo",
      "primary": true,
      "skipSearch": false
    }],
    "san-felicino": [{
      "hkey": "dbe1bc8e",
      "slug": "peschiera-borromeo",
      "name": "Peschiera Borromeo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "12bdae22": [{
      "hkey": "a8aad041",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "zelo": [{
      "hkey": "a8aad041",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "peschiera-borromeo"
    }]
  }
};
exports["default"] = _default;